import React from "react";
import "../styles/PdfViewer.scss";

const PdfViewer = ({ url }) => {
  const pdfUrl =
    url ||
    "https://mozilla.github.io/pdf.js/web/compressed.tracemonkey-pldi-09.pdf";

  return (
    <div className="pdf-viewer-container">
      <div className="pdf-frame-container">
        <iframe src={pdfUrl} title="PDF Viewer" width="100%" height="100%" />
      </div>
    </div>
  );
};

export default PdfViewer;
